var map = {
	"./Albedo.png": 66,
	"./Aloy.png": 67,
	"./Amber.png": 68,
	"./Arataki Itto.png": 69,
	"./Ayaka.png": 70,
	"./Ayato.png": 71,
	"./Barbara.png": 72,
	"./Beidou.png": 73,
	"./Bennet.png": 74,
	"./Candace.png": 75,
	"./Chongyun.png": 76,
	"./Collei.png": 77,
	"./Cyno.png": 78,
	"./Diluc.png": 79,
	"./Diona.png": 80,
	"./Dori.png": 81,
	"./Eula.png": 82,
	"./Faruzan.png": 83,
	"./Fischl.png": 84,
	"./Ganyu.png": 85,
	"./Gorou.png": 86,
	"./Hutao.png": 87,
	"./Jean.png": 88,
	"./Kaedehara Kazuha.png": 89,
	"./Kaeya.png": 90,
	"./Keqing.png": 91,
	"./Klee.png": 92,
	"./Kokomi.png": 93,
	"./Kujou Sara.png": 94,
	"./Kuki Shinobu.png": 95,
	"./Layla.png": 96,
	"./Lisa.png": 97,
	"./Mona.png": 98,
	"./Nahida.png": 99,
	"./Nilou.png": 100,
	"./Ningguang.png": 101,
	"./Noelle.png": 102,
	"./Qiqi.png": 103,
	"./Raiden Shogun.png": 104,
	"./Razor.png": 105,
	"./Rosaria.png": 106,
	"./Sayu.png": 107,
	"./Shenhe.png": 108,
	"./Shikanoin heizou.png": 109,
	"./Sucrose.png": 110,
	"./Tartaglia.png": 111,
	"./Thoma.png": 112,
	"./Tighnari.png": 113,
	"./Venti.png": 114,
	"./Xiangling.png": 115,
	"./Xiao.png": 116,
	"./Xingqiu.png": 117,
	"./Xinyan.png": 118,
	"./Yae Miko.png": 119,
	"./Yanfei.png": 120,
	"./Yelan.png": 121,
	"./Yoimiya.png": 122,
	"./Yunjin.png": 123,
	"./Zhongli.png": 124,
	"./andarilho.png": 125,
	"./undefined.png": 126
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 65;